const data_ubi={

    'LEON':{
        latitud:'21.126663979992287',
        longitud:'-101.68945082614917'
    },
    'CELAYA':{
        
        latitud:'20.527887770390237',
        longitud:'-100.81242662434393'
    },
    'IRAPUATO':{
        latitud:'20.67818558153614',
        longitud:'-101.35726371378621'
    },
    'GUANAJUATO':{
        latitud:'21.018103148449267',
        longitud:'-101.25883601283083'
    },
    'SAN MIGUEL DE ALLENDE':{
        latitud:'20.914855299704314',
        longitud:'-100.74539116944273'
    },
    'SAN LUIS DE LA PAZ':{
        latitud:'21.293480594544377',
        longitud:'-100.52295015229237'
    },
    'SILAO':{
        latitud:'20.945518955984046',
        longitud:'-101.43326565985306'
    },
    'DOLORES HIDALGO':{
        latitud:'21.159031263138324',
        longitud:'-100.94410045707372'
    },
}
export default data_ubi